var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IntegrationSettingsMenu',{attrs:{"name":"Mayday Desk","features":_vm.features,"preferences":_vm.preferences,"disabled":_vm.disabled,"integration":_vm.integration.value,"noInstall":_vm.noInstall}})
}
var staticRenderFns = []

export { render, staticRenderFns }